import React, {useEffect, useState} from 'react';
import styles from './ordre.module.css';
import Loader from '../../../loader';
import { axiosAuthFetch } from '../../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../../constants';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import CustomAlert from '../../../customAlert';

export default function VpAdminOrdrePage(){

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [filterStatus, setFilterStatus] = useState('all');
    const [sortOrder, setSortOrder] = useState('dateDesc');
    const [searchTerm, setSearchTerm] = useState('');
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [orderToDelete, setOrderToDelete] = useState(null);
    const [deleteAlertData, setDeleteAlertData] = useState({
        show: false,
        message: '',
        isError: false,
    });
    const [approveAlertData, setApproveAlertData] = useState({
        show: false,
        message: '',
        isError: false,
    });

    const formatPrice = (price) => {
        return new Intl.NumberFormat('no-NO', { style: 'decimal' }).format(price);
    };

    const url = `${API_BASE_URL}/orders?populate=*`;

    useEffect(() => {
        async function retrieveOrders(){
            try{
                const response = await axiosAuthFetch(url)
                console.log(response.data);
                setOrders(response.data);
            }
            catch(error){
                console.error(error);
                setIsError(true);
            }
            finally{
                setIsLoading(false);
            }
        }
        retrieveOrders()
    }, [url]);

    const openModal = (order) => {
        setSelectedOrder(order);
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setSelectedOrder(null);
        setIsModalOpen(false);
    }

    const handleApprove = async (orderId) => {
        setIsLoading(true);
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/orders/${orderId}`, { data: { status: 'approved' } }, 'PUT');
            console.log('order approved', response.data);
            setApproveAlertData({
                show: true,
                message: 'Ordren er godkjent! ',
                isError: false,
            });
            setOrders(prevOrders => prevOrders.map(order => {
                if (order.id === orderId) {
                    return { ...order, attributes: { ...order.attributes, status: 'approved' } };
                }
                return order;
            }));
        } catch (error) {
            console.error('Error approving order:', error);
            setApproveAlertData({
                show: true,
                message: 'Det oppstod en feil ved godkjenning av ordren. Vennligst prøv igjen.',
                isError: true,
            });
        }
        setIsLoading(false);
    };

    const handleReject = async (orderId) => {
        setIsLoading(true);
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/orders/${orderId}`, { data: { status: 'rejected' } }, 'PUT');
            console.log('order rejected', response.data);
            setApproveAlertData({
                show: true,
                message: 'Ordren er avslått!',
                isError: false,
            });
            setOrders(prevOrders => prevOrders.map(order => {
                if (order.id === orderId) {
                    return { ...order, attributes: { ...order.attributes, status: 'rejected' } };
                }
                return order;
            }));
        } catch (error) {
            console.error('Error rejecting order:', error);
            setApproveAlertData({
                show: true,
                message: 'Det oppstod en feil ved avslag av ordren. Vennligst prøv igjen.',
                isError: true,
            });
        }
        setIsLoading(false);
    };

    const handleDeleteClick = async (orderId) => {
        console.log('handle delete')
        setOrderToDelete(orderId);
        setShowConfirmDelete(true);
    };

    const confirmDelete = async () => {
        setIsLoading(true);
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/orders/${orderToDelete}`, {}, 'DELETE');
            console.log('order deleted', response.data);
            setDeleteAlertData({
                show: true,
                message: 'Ordren er slettet!',
                isError:false,
            });
            setOrders(prevOrders => prevOrders.filter(order => order.id !== orderToDelete));
        } catch(error) {
            console.error(error);
            setDeleteAlertData({
                show:true,
                message:'Oida, noe gikk galt! Vennligst prøv igjen.',
                isError:true,
            })
        }
        setIsLoading(false);
        setShowConfirmDelete(false);
    }

    const filteredOrders = orders
        .filter(order => {
            if (filterStatus === 'approved') {
                return order.attributes.status === 'approved';
            } else if (filterStatus === 'rejected') {
                return order.attributes.status === 'rejected';
            } else if (filterStatus === 'pending') {
                return order.attributes.status === 'pending';
            }
            return true;
        })
        .filter(order => {
            if (searchTerm) {
                return order.attributes.user.data.attributes.username.toLowerCase().includes(searchTerm.toLowerCase());
            }
            return true;
        })
        .sort((a, b) => {
            if (sortOrder === 'dateAsc') {
                return new Date(a.attributes.dateOrdered) - new Date(b.attributes.dateOrdered);
            }
            return new Date(b.attributes.dateOrdered) - new Date(a.attributes.dateOrdered);
        });

    if(isLoading) {
        return(<Loader />)
    }
    if(isError) {
        return(<>Noe gikk feil ved innlasting av ordre. Prøv på nytt eller ta kontakt for å løse problemet!</>)
    }
    return(
        <div className={styles.container}>
            <div className={styles.overskrift}>
                Ordreoversikt
            </div>
            <div className={styles.filterContainer}>
                <Form className={styles.formContainer}>
                    <Form.Group className={styles.formGroup} controlId="filterStatus">
                        <Form.Label>Filter Status</Form.Label>
                        <Form.Control as="select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                            <option value="all">Alle</option>
                            <option value="approved">Godkjente</option>
                            <option value="rejected">Avslåtte</option>
                            <option value="pending">Ventende</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className={styles.formGroup} controlId="sortOrder">
                        <Form.Label>Sorter Etter</Form.Label>
                        <Form.Control as="select" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                            <option value="dateDesc">Dato (nyeste først)</option>
                            <option value="dateAsc">Dato (eldste først)</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className={styles.formGroup} controlId="searchTerm">
                        <Form.Label>Søk Bruker</Form.Label>
                        <Form.Control type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </Form.Group>
                </Form>
            </div>
            <div className={styles.container2}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Bestilt av</th>
                            <th>Bestillingsdato</th>
                            <th>Total Pris</th>
                            <th>Antall produkter</th>
                            <th>Status</th>
                            <th>Handlinger</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.map((order) => (
                            <tr className={styles.container3} key={order.id}>
                                <td onClick={() => openModal(order)}>{order?.attributes?.user?.data?.attributes?.username}</td>
                                <td onClick={() => openModal(order)}>{order.attributes.dateOrdered}</td>
                                <td onClick={() => openModal(order)}>{formatPrice(order.attributes.total_price)},-</td>
                                <td onClick={() => openModal(order)}>{order.attributes.order_product.length}</td>
                                <td onClick={() => openModal(order)}>
                                    {order.attributes.status === 'approved' && 'Godkjent'}
                                    {order.attributes.status === 'rejected' && 'Avslått'}
                                    {order.attributes.status === 'pending' && 'Ventende'}
                                </td>
                                <td>
                                    <div className={styles.buttonContainer}>
                                        <div className={styles.button1} onClick={() => handleApprove(order.id)}>Godkjenn</div>
                                        <div className={styles.button2} onClick={() => handleReject(order.id)}>Avslå</div>
                                        <div className={styles.button3} onClick={() => handleDeleteClick(order.id)}>Slett</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <CustomAlert
                show={approveAlertData.show}
                handleClose={() => setApproveAlertData({ show: false, message: '', isError: false })}
                message={approveAlertData.message}
                isError={approveAlertData.isError}
                buttonLabel="Jeg forstår!"
                buttonClassName="login-button text-white"
                modalTitle="Godkjenn Ordre"
            />

            <Modal show={showConfirmDelete} onHide={() => setShowConfirmDelete(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Bekreft sletting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Er du sikker på at du vil slette ordren? Slettede ordre finner du ikke igjen.
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.button2} onClick={() => setShowConfirmDelete(false)}>Avbryt</div>
                    <div className={styles.button3} onClick={confirmDelete}>Slett</div>
                </Modal.Footer>
            </Modal>

            <CustomAlert
                show={deleteAlertData.show}
                handleClose={() => setDeleteAlertData({ show: false, message: '', isError: false })}
                message={deleteAlertData.message}
                isError={deleteAlertData.isError}
                buttonLabel="Jeg forstår!"
                buttonClassName="login-button text-white"
                modalTitle="Slett Ordre"
            />

            {selectedOrder && (
                <Modal show={isModalOpen} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ordredetaljer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={styles.modalContainer}>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>
                                    Bestilt av: 
                                </div>
                                <div className={styles.dynamisk}>{selectedOrder?.attributes?.user?.data?.attributes?.username}</div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>
                                    Bestillingsdato: 
                                </div>
                                <div className={styles.dynamisk}>{selectedOrder.attributes.dateOrdered}</div>
                            </div>
                            <div className={styles.produktRow}>
                                <div className={`${styles.produktUnderoverskrift}`}>Produkter:</div>
                            </div>
                            <ul className={styles.produktListeParent}>
                                {selectedOrder.attributes.order_product.map((product) => (
                                    <li className={styles.produktListeChild} key={product.id}>
                                        <div className={styles.info}>{product.name} - {formatPrice(product.price)},-</div>
                                        <div className={styles.antall}>x {product.quantity}</div>
                                    </li>
                                ))}
                            </ul>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>
                                    Total pris: 
                                </div>
                                <div className={styles.dynamisk}>
                                    {formatPrice(selectedOrder.attributes.total_price)},-
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>
                                    Status:
                                </div>
                                <div className={styles.dynamisk}>
                                    {selectedOrder.attributes.status === 'approved' && 'Godkjent'}
                                    {selectedOrder.attributes.status === 'rejected' && 'Avslått'}
                                    {selectedOrder.attributes.status === 'pending' && 'Ventende'}
                                </div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>Kontaktperson:</div>
                                <div className={styles.dynamisk}>{selectedOrder.attributes.contact_person}</div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>Kontakt e-post:</div>
                                <div className={styles.dynamisk}>{selectedOrder.attributes.contact_email}</div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.underoverskrift}>Kjøpers kommentar:</div>
                                <div className={styles.dynamisk}>{selectedOrder.attributes.comment}</div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className={styles.button4} onClick={closeModal}>Lukk</div>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    )
}